import React from "react";
import { Box, Typography } from "@mui/material";
import { Person } from "../../../types/person";
import usePersonConnectionController from "../../../controllers/connections/personConnectionController";
import PersonConnectionTable from "../../../components/tables/PersonConnectionTable";
import { SYSTEM_PERSON_IMPLIES_CONNECTION_TYPES } from "../../../types/personConnection";
import { personImpliesConnectionColumns } from "../../../common/entities/PersonConnectionColumns";

interface PersonImpliesSectionProps {
  person: Person;
}

const PersonImpliesSection: React.FC<PersonImpliesSectionProps> = ({
  person,
}) => {
  const controller = usePersonConnectionController({ to: person });
  return (
    <Box>
      <Typography variant="h2" mb={4}>
        Person Implies Connections
      </Typography>
      <PersonConnectionTable
        controller={controller}
        columns={personImpliesConnectionColumns}
        filters={{
          system_person_connection_type: SYSTEM_PERSON_IMPLIES_CONNECTION_TYPES,
        }}
      />
    </Box>
  );
};

export default PersonImpliesSection;
